import React from 'react'
import {
  SofaIcon,
  TableDiamondIcon,
  TableBigIcon,
  TableSquareBlueIcon,
  TableSquareIcon
} from '../../assets/icons/index'

export const getTicketTypeIcon = (ticket = {}, ticketGroupName) => {
  const { ticket_type_name: ticketTypeName } = ticket

  switch (ticketTypeName || ticketGroupName) {
    case 'Booths':
      return <SofaIcon className='seatLabelIcon' width={40} />
    case 'Mesas | Tables':
      return <TableDiamondIcon className='seatLabelIcon' width={30} />
    case 'Playa | Beach':
    case 'Sala':
      return <TableBigIcon className='seatLabelIcon' width={40} />
    case 'Pista | Dance Floor':
      return <TableSquareIcon className='seatLabelIcon' width={30} />
    case 'Ocean Front Tables':
      return <TableSquareBlueIcon className='seatLabelIcon' width={30} />
    default:
      return <span style={{ padding: '0 5px' }} />
  }
}
